import { IconButton, Icon, Row, Col } from 'rsuite'
import { useHistory } from 'react-router-dom'
import { sessionRemoveItem } from '../../../utils/sessionHelpers'

export default function GoBackButton({
  onClick,
  children = 'ย้อนกลับ',
  icon = 'arrow-circle-left',
  disabled,
  cleanSessions = [],
  ...props
}) {
  let history = useHistory()

  return (
    <Row style={{ textAlign: 'right' }}>
      <IconButton
        style={{
          marginRight: 10,
          // marginBottom: 10,
        }}
        // onClick={onClick}
        onClick={() => {
          cleanSessions?.forEach((e) => {
            sessionRemoveItem(e)
          })

          history.goBack()
        }}
        icon={<Icon appearance="ghost" icon={icon} />}
        disabled={disabled}
        {...props}
      >
        {children}
      </IconButton>
    </Row>
  )
}
